import { createContext as i, useContext as x } from "react";
const C = (n = {}) => {
  const {
    strict: c = !0,
    errorMessage: s = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name: a
  } = n, t = i(void 0);
  t.displayName = a;
  const r = () => {
    const o = x(t);
    if (!o && c) {
      const e = new Error(s);
      throw e.name = "ContextError", Error.captureStackTrace?.(e, r), e;
    }
    return o;
  };
  return [t.Provider, r, t];
};
export {
  C as createContext
};
//# sourceMappingURL=context.js.map
